import styled from "styled-components";
import {
  AppBar,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import axios from "axios";
import { PillarChart } from "./PillarChart";
import Icon from "../../components/Icon";
import SelectStudentModal from "../../components/SelectStudentModal";
import { useScreenClass } from "react-grid-system";
import { StyledAddButton } from "../RoadMap/RoadMap";
import { CustomFlex } from "../RoadMap/RoadMapTimeline";
import { UserContext } from "../../context/UserContext";
import Pill from "../../components/Pill";

export const InstructorView = () => {
  const CustomLayout = styled.div`
    padding: 12px;
    height: 80vh; /* Ensure a defined height for the container */
  `;

  const sofData = [
    {
      subject: "SOF-101",
      A: 1,
    },
    {
      subject: "SOF-201",
      A: 4,
    },
    {
      subject: "SOF-301",
      A: 0,
    },
    {
      subject: "SOF-401",
      A: 4,
    },
    {
      subject: "SOF-501",
      A: 3,
    },
    {
      subject: "SOF-601",
      A: 4,
    },
    {
      subject: "SOF-701",
      A: 3,
    },
  ];

  const [coreData, setCoreData] = useState([]);
  const [nonCoreData, setNonCoreData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const selectedStudent: any = JSON.parse(
    localStorage.getItem("selectedStudent") as string
  );
  const [isEmptyData, setIsEmptyData] = useState(true);
  const screenClass = useScreenClass();
  const userContext = useContext(UserContext);

  const isMobile = useMemo(
    () => ["xs", "sm", "md"].includes(screenClass),
    [screenClass]
  );

  useEffect(() => {
    localStorage.getItem("selectedStudent") &&
      getMasterySummary(
        JSON.parse(localStorage.getItem("selectedStudent") as string).id
      );
  }, []);

  const getMasterySummary = (student_id: string) => {
    axios
      .get(`/student/mastery_summary?student_id=${student_id}`)
      .then((res: any) => {
        setIsEmptyData(false);
        if (res?.data?.mastery_summary?.length > 0) {
          const core: any = [];
          const nonCore: any = [];
          res.data.mastery_summary.map((v: any) => {
            if (v.is_core) {
              core.push(v);
            } else nonCore.push(v);
          });
          setCoreData(core);
          setNonCoreData(nonCore);
        } else {
          setIsEmptyData(true);
        }
      })
      .catch(() => {});
  };
  const [selectedOption, setSelectedOption] = useState("all");

  if (!selectedStudent) {
    return (
      <>
        {isModalOpen && (
          <SelectStudentModal
            isOpen={isModalOpen}
            setOpen={setIsModalOpen}
            setStudent={(stu) => {
              localStorage.setItem("selectedStudent", JSON.stringify(stu));
              getMasterySummary(stu.id);
            }}
          />
        )}
        <FlexGrow style={{ position: "absolute", top: -40, zIndex: 10000 }}>
          <StyledAddButton
            style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            {!isMobile && window.screen.width > 1140 ? (
              <>
                {selectedStudent && selectedStudent.nickname ? (
                  <>
                    <Icon
                      fixedWidth={false}
                      style={{ width: "24px", height: "24px" }}
                      size={3}
                      mr={1}
                      name="user"
                    />
                    {selectedStudent.nickname}
                  </>
                ) : (
                  <>
                    <Icon
                      fixedWidth={false}
                      style={{ width: "24px", height: "24px" }}
                      size={3}
                      mr={1}
                      name="user"
                    />
                    Select Student
                  </>
                )}
              </>
            ) : (
              <>
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  name="plus-circle"
                />
              </>
            )}
          </StyledAddButton>
        </FlexGrow>
        <Pill
          style={{
            background: "#ff002447",
            position: "absolute",
            top: "30vh",
            left: "47%",
            fontSize: "x-large",
            padding: 20,
          }}
        >
          Select a student
        </Pill>
      </>
    );
  }
  return (
    <CustomLayout>
      {isModalOpen && (
        <SelectStudentModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          setStudent={(stu) => {
            localStorage.setItem("selectedStudent", JSON.stringify(stu));
            getMasterySummary(stu.id);
          }}
        />
      )}
      <FlexGrow style={{ position: "absolute", top: -40, zIndex: 10000 }}>
        <StyledAddButton
          style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          {!isMobile && window.screen.width > 1140 ? (
            <>
              {selectedStudent && selectedStudent.nickname ? (
                <>
                  <Icon
                    fixedWidth={false}
                    style={{ width: "24px", height: "24px" }}
                    size={3}
                    mr={1}
                    name="user"
                  />
                  {selectedStudent.nickname}
                </>
              ) : (
                <>
                  <Icon
                    fixedWidth={false}
                    style={{ width: "24px", height: "24px" }}
                    size={3}
                    mr={1}
                    name="user"
                  />
                  Select Student
                </>
              )}
            </>
          ) : (
            <>
              <Icon
                fixedWidth={false}
                style={{ width: "24px", height: "24px" }}
                size={3}
                name="plus-circle"
              />
            </>
          )}
        </StyledAddButton>
      </FlexGrow>
      {!isEmptyData ? (
        <>
          {/* <FlexBox>
            <Radio
              checked={selectedOption === "all"}
              onChange={() => setSelectedOption("all")}
              value="a"
              name="radio-buttons"
              inputProps={{ "aria-label": "A" }}
              sx={{
                color: "white",
              }}
            />
            All Pillars
            <Radio
              disabled
              checked={selectedOption === "sof"}
              onChange={() => setSelectedOption("sof")}
              value="b"
              name="radio-buttons"
              inputProps={{ "aria-label": "B" }}
              sx={{
                marginLeft: 5,
                color: "white",
              }}
            />
            SOF PIllars
          </FlexBox> */}

          <div style={{ display: "flex", height: "70vh" }}>
            <h3
              style={{
                position: "fixed",
                zIndex: 1000,
                left: "50%",
                top: 26,
                transform: "translateX(-50%)",
              }}
            >
              My Profile
            </h3>
            {selectedOption === "all" ? (
              <>
                <PillarChart
                  data={coreData}
                  stroke={"#007BFF"}
                  fill={"#4e8aff"}
                  label="Core Pillars"
                />
                <PillarChart
                  data={nonCoreData}
                  stroke={"#FFD700"}
                  fill={"#ffe364"}
                  label="Non-Core Pillars"
                />
              </>
            ) : (
              <PillarChart
                data={sofData}
                stroke={"#007BFF"}
                fill={"#4e8aff"}
                label="SOF Pillars"
              />
            )}
          </div>
        </>
      ) : (
        <Pill
          style={{
            background: "#ff002447",
            position: "absolute",
            top: "30vh",
            left: "47%",
            fontSize: "x-large",
            padding: 20,
          }}
        >
          No Record for the student!
        </Pill>
      )}
    </CustomLayout>
  );
};
